import { useContext } from "react";
import { ensure, mapToNamedProperty } from "sprint-common-web";

import { DeliveryEndpointsDataContext } from "../../../../../common/data/lookup-data-providers/DeliveryEndpointsDataProvider";
import { DeliveryEndpointType } from "../../../../../common/types/DeliveryEndpointType";
import { useAdminAirlineApi } from "../../../../airline/common/api/useAdminAirlineApi";
import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { useDeliveryInfo } from "../useDeliveryInfo";
import { EditAsperaDeliveryInfoFormInputs } from "./EditAsperaDeliveryInfoForm";

export const useEditAsperaDeliveryInfoForm = () => {
    const { updateDeliveryInfo } = useAdminAirlineApi();
    const { deliveryEndpoint } = useDeliveryInfo();

    const { systemPlatformDetailsItem, updateDeliveryInfo: updateDeliveryInfoItem } = useContext(
        SystemPlatformDetailsContext
    );
    const { deliveryEndpoints } = useContext(DeliveryEndpointsDataContext);

    const asperaDeliveryEndpoints = deliveryEndpoints.filter(
        (item) =>
            item.type === DeliveryEndpointType.Aspera && item.integrator.id === systemPlatformDetailsItem.integrator.id
    );

    const itemToEdit = {
        deliveryEndpoint,
        type: deliveryEndpoint?.type
    };

    const editAsperaDeliveryInfo = async ({ deliveryEndpointId }: EditAsperaDeliveryInfoFormInputs) => {
        await updateDeliveryInfo({
            airlineId: systemPlatformDetailsItem.airline.id,
            systemId: systemPlatformDetailsItem.system.id,
            deliveryEndpointId
        });

        const endpoint = deliveryEndpoints.find((item) => item.id === deliveryEndpointId);
        ensure(endpoint);

        updateDeliveryInfoItem({
            deliveryEndpoint: mapToNamedProperty(endpoint),
            distributionList: undefined
        });
    };

    return {
        itemToEdit,
        deliveryEndpoints: asperaDeliveryEndpoints,
        editAsperaDeliveryInfo
    };
};
